import { render, staticRenderFns } from "./SpecialistTeamSection.vue?vue&type=template&id=d54c1236&scoped=true&lang=pug&"
import script from "./SpecialistTeamSection.vue?vue&type=script&lang=js&"
export * from "./SpecialistTeamSection.vue?vue&type=script&lang=js&"
import style0 from "./SpecialistTeamSection.vue?vue&type=style&index=0&id=d54c1236&prod&scoped=true&lang=sass&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d54c1236",
  null
  
)

export default component.exports